import { type Tokens } from "../types"

export const COOKIE_CONFIG = {
  secure: true,
  sameSite: "strict" as const,
  path: "/",
}

export const TOKEN_MAP: Record<keyof Tokens, string> = {
  idToken: "id_token",
  accessToken: "access_token",
  refreshToken: "refresh_token",
}
